import https from "@/utils/http";

const mine = {
  // 登录
  getLoginByCode(data) {
    return https({
      url: "/api/public/gpt/user/loginByCode",
      method: "POST",
      isToken: "no",
      data,
    });
  },
  // 获取验证码
  getSMSCode(data) {
    return https({
      url: "/api/public/gpt/user/getSMSCode1",
      method: "POST",
      isToken: "no",
      data,
    });
  },
  // 获取充值紫水晶列表
  getCoinProducts() {
    return https({
      url: "/api/public/gpt/vip/coinProducts",
      method: "POST",
      isToken: "no",
    });
  },
  // 获取充值会员列表
  getVipProducts() {
    return https({
      url: "/api/public/gpt/vip/products",
      method: "POST",
      isToken: "no",
    });
  },
  // 紫水晶明细
  getCoinRecordList(params) {
    return https({
      url: "/api/public/gpt/user/getCoinRecord",
      method: "GET",
      params,
    });
  },
  // 签到
  getCheckInDaily() {
    return https({
      url: "/api/public/gpt/user/checkInDaily",
      method: "POST",
    });
  },
  // 领取邀请奖励
  getSetMyInvite(data) {
    return https({
      url: "/api/public/gpt/user/setMyInvite",
      method: "POST",
      data,
    });
  },
  // 获取任务列表,添加邀请任务
  getTasksV1() {
    return https({
      url: "/api/public/gpt/user/getTasksV1",
      method: "GET",
    });
  },
  // 获取用户信息
  getGptUserInfo(data) {
    return https({
      url: "/api/public/gpt/user/getUserInfo",
      method: "POST",
      data,
    });
  },
  // 注销账户
  getGptLogoff() {
    return https({
      url: "/api/public/gpt/user/closeAccount",
      method: "POST",
    });
  },
  // 兑换码兑换
  getRedemptionCode(data) {
    return https({
      url: "/api/public/gpt/user/redemption",
      method: "POST",
      data,
    });
  },
};
export default mine;
